<template>
  <div>
    <!-- <h1>Login</h1>
    <form v-on:submit.prevent="login()">
      <input type="text" v-model="user">
      <input type="password" v-model="password">
      <button @click="login()">Login</button>
    </form> -->

    <form v-on:submit.prevent="login()" class="login">
    <h1 class="login-title">Daily - Login</h1>
    <input v-model="user" type="text" class="login-input" placeholder="Email Adress" autofocus>
    <input v-model="password" type="password" class="login-input" placeholder="Password">
    <input type="submit" value="Login" class="login-button">
  <!-- <p class="login-lost"><a href="">Forgot Password?</a></p> -->
  </form>

  </div>
</template>

<script>
export default {
  data: function(){
    return {
      user: '',
      password: ''
    }
  },
  methods:{
    login: async function(){
      let response = await i_axios.post('/auth', {user:this.user, password:this.password});
      if(response.data.error){
        alert(response.data.error)
        return;
      }
      localStorage.setItem('_auid', response.data._auid);
      this.$router.push({'path' : '/'});
      // this.$router.go(0);
      location.reload();
    }
  }
}
</script>

<style scoped>

body {
  background: #2d343d;
}
input {
  height:auto !important;
  /* width:auto !important; */
}

.login {
  margin: 20px auto;
  width: 340px;
  padding: 30px 25px;
  background: white;
  border: 1px solid #c4c4c4;
}

h1.login-title {
  margin: -28px -25px 25px;
  padding: 15px 25px;
  line-height: 30px;
  font-size: 25px;
  font-weight: 300;
  color: #ADADAD;
  text-align:center;
  background: #f7f7f7;
 
}

.login-input {
  width: 285px;
  height: 50px;
  margin-bottom: 25px;
  padding-left:10px;
  font-size: 15px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.login-input:focus {
    border-color:#6e8095;
    outline: none;
  }
.login-button {
  width: 100%;
  height: 50px !important;
  padding: 0;
  font-size: 20px;
  color: black;
  text-align: center;
  background: lightgreen;
  border: 0;
  border-radius: 5px;
  cursor: pointer; 
  outline:0;
}

.login-lost
{
  text-align:center;
  margin-bottom:0px;
}

.login-lost a
{
  color:#666;
  text-decoration:none;
  font-size:13px;
}




</style>
